import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { QuotaService } from '../auth/services/quota.service';
import { ToastService } from '../services/toast.service';

const STORAGE_FULL_MESSAGE = 'Your storage is full. Delete something from Drive or use Quick Edit to keep editing locally without saving to storage.';

export const quotaInterceptor: HttpInterceptorFn = (req, next) => {
  const quotaService = inject(QuotaService);
  const toast = inject(ToastService);

  return next(req).pipe(
    catchError((error) => {
      if (error.status === 402 && error.error?.errorCode === 'STORAGE_QUOTA_EXCEEDED') {
        toast.error(STORAGE_FULL_MESSAGE, 7000);
      } else if (error.status === 402 && error.error?.errorCode === 'QUOTA_EXCEEDED') {
        quotaService.openQuotaModal(error.error?.message);
      }
      return throwError(() => error);
    })
  );
};
